module.exports = __webpack_public_path__ + "img/IElephantArcher64_ua.f4f7466f.webp";